export default "__VITE_ASSET__00011736__"